export default __webpack_public_path__ + "static/media/image2-1.24037b1d.png";